var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07422 8.94727C7.07422 8.39498 7.52193 7.94727 8.07422 7.94727L19.0742 7.94727C19.6265 7.94727 20.0742 8.39498 20.0742 8.94727C20.0742 9.49955 19.6265 9.94727 19.0742 9.94727L8.07422 9.94727C7.52193 9.94727 7.07422 9.49955 7.07422 8.94727Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07422 11.9473C7.07422 11.395 7.52193 10.9473 8.07422 10.9473H19.0742C19.6265 10.9473 20.0742 11.395 20.0742 11.9473C20.0742 12.4996 19.6265 12.9473 19.0742 12.9473H8.07422C7.52193 12.9473 7.07422 12.4996 7.07422 11.9473Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07422 14.9473C7.07422 14.395 7.52193 13.9473 8.07422 13.9473H15.0742C15.6265 13.9473 16.0742 14.395 16.0742 14.9473C16.0742 15.4996 15.6265 15.9473 15.0742 15.9473H8.07422C7.52193 15.9473 7.07422 15.4996 7.07422 14.9473Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8045 13.5071C21.5856 12.726 22.8519 12.726 23.633 13.5071L24.34 14.2141C25.1211 14.9952 25.1211 16.2615 24.34 17.0426L18.6081 22.7746C18.1964 23.1863 17.6739 23.4692 17.1042 23.5891L15 24.0316C14.6693 24.1012 14.326 23.9991 14.087 23.7602C13.8481 23.5212 13.746 23.1779 13.8156 22.8472L14.2581 20.743C14.3779 20.1733 14.6609 19.6508 15.0726 19.2391L20.8045 13.5071ZM22.4863 16.0679L22.9258 15.6284L22.2188 14.9213L21.7792 15.3608L22.4863 16.0679ZM20.365 16.775L16.4868 20.6533C16.3496 20.7906 16.2552 20.9647 16.2153 21.1546L16.0882 21.759L16.6926 21.6319C16.8825 21.592 17.0566 21.4976 17.1938 21.3604L21.0721 17.4821L20.365 16.775Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.76ff5e04071037b34c4fea30c4626b1a.svg";